import { isLegacyActionRecord, isPatchBasedActionRecord, } from "@buildwithflux/models";
import { revertChange } from "deep-diff";
import { apply, isDraft } from "mutative";
import { getImmerPatches } from "../../../history";
import { applyPatchesFast } from "./applyPatchesFast";
/**
 * Apply a backwards-going deep diff to a document.  These come from legacy action records.
 *
 * @deprecated use revertPatchFromActionRecord instead
 */
export function revertDeepDiffFromActionRecord(doc, deepDiff) {
    for (const diff of Object.values(deepDiff)) {
        // NOTE: In previous versions of this function, it was necessary to convert the diff in the
        // action record to an "unflattened" representation.  This is no longer needed because that work
        // is delegated to the storage layer, so all objects are unflattened once they are in memory.
        revertChange(doc, true, diff);
    }
    return doc;
}
/**
 * Apply a backwards-going patch to a document.
 *
 * NOTE: You may want to update latestActionRecordUid after calling this function.
 *
 * @see revertActionRecords block in reducer
 * @see applyPatchReverse for similar logic
 */
export function revertPatchFromActionRecord(doc, patch) {
    const { reverse } = getImmerPatches(patch);
    try {
        apply(doc, reverse);
    }
    catch (error) {
        if (error instanceof Error && isDraft(doc)) {
            applyPatchesFast(doc, reverse);
        }
        else {
            throw error;
        }
    }
    return doc;
}
/**
 * QUESTION: why are forkDocument and createDocument special-cased here? why not
 * rely on actionShouldBeAppliedUnconditionally? and what about cloneDocument?
 */
function getRevertibleActionRecords(records) {
    return records.filter((record) => record.actionName !== "createDocument" && record.actionName !== "forkDocument");
}
/**
 * Apply a collection of backwards-going action records (in the provided sequence) to a document.
 */
export function revertActionRecords(doc, actionRecords) {
    if (!isDraft(doc)) {
        // NOTE: This is important to guarantee undo/redo is synced to remote session correctly
        throw new Error("Please pass in a draft document to revertActionRecords, so that applying patches doesn't replace the whole document state and result in broken patches");
    }
    getRevertibleActionRecords(actionRecords).reduce((acc, record) => {
        if (isPatchBasedActionRecord(record))
            return revertPatchFromActionRecord(acc, record.actionChangeDiff);
        else if (isLegacyActionRecord(record))
            return revertDeepDiffFromActionRecord(acc, record.actionChangeDiff);
        throw new Error(`cannot recognize format of action record: ${JSON.stringify(record)}`);
    }, doc);
}
//# sourceMappingURL=revert.js.map